import {
    AUTH_LOGIN,
    AUTH_LOGIN_SUCCESS,
    AUTH_LOGIN_FAIL,
    AUTH_LOGOUT,
    FORGOT_PASSWORD,
    FORGOT_PASSWORD_SUCCESS,
    FORGOT_PASSWORD_FAIL,
} from "../actions/types";

const initialState = {
    loading: false,
    errors: [],
    error: '',
    message: '',
};

export default function (state = initialState, action) {
    switch (action.type) {
        case AUTH_LOGIN: {
            return {
                ...state,
                loading: true,
                errors: [],
            };
        }
        case AUTH_LOGIN_SUCCESS: {
            return {
                ...state,
                loading: false
            };
        }
        case AUTH_LOGIN_FAIL: {
            return {
                ...state,
                loading: false,
                errors: action.payload
            };
        }
        case AUTH_LOGOUT: {
            return {
                ...state,
                loading: false,
            };
        }
        case FORGOT_PASSWORD: {
            return {
                ...state,
                loading: true,
                success: false,
                error: '',
                message: '',
            };
        }
        case FORGOT_PASSWORD_SUCCESS: {
            return {
                ...state,
                loading: false,
                message: action.payload
            };
        }
        case FORGOT_PASSWORD_FAIL: {
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        }

        default:
            return state;
    }
}